import { createAsyncThunk } from "@reduxjs/toolkit";

import { type AsyncThunkCreator } from "../../../index";
import { TRAINEE_REDUCER_NAME } from "../types";

type Payload = {
  id: string;
  tags: string[];
};

type UpdatedTags = {
  id: string;
  tags: string[];
  updatedAt: string;
};

// Sales reps have no UPDATE policy on trainee — tags go through a column-scoped
// security definer RPC that returns only the tag projection, never the full
// trainee row (TRE-1636).
export const updateTraineeTags = createAsyncThunk<UpdatedTags, Payload, AsyncThunkCreator<string>>(
  `${TRAINEE_REDUCER_NAME}/updateTraineeTags`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { data, error } = await db
      .rpc("update_trainee_tags_as_sales_rep", {
        p_trainee_id: payload.id,
        p_tags: payload.tags,
      })
      .returns<UpdatedTags[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    const updated = data?.[0];

    if (!updated) {
      return rejectWithValue("Nie udało się zaktualizować tagów");
    }

    analytics.track("update_trainee_tags");

    return updated;
  },
);
